const isSVG = (target) => target instanceof SVGElement && 'getBBox' in target;
const isHidden = (target) => {
    if (isSVG(target)) {
        const { width, height } = target.getBBox();
        return !width && !height;
    }
    const { offsetWidth, offsetHeight } = target;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
export { isSVG, isHidden };
